module.exports = __webpack_public_path__ + "static/media/headerBottom.5f5a0c63.svg";